module.exports = __webpack_public_path__ + "img/two_side_left_img.4a540b0f.png";